import { isCdrBody } from '@/types/cdr/CdrType'
import { isCdrResponse } from '../types/cdr/CdrResponse'
import CdrBodyModelTranslator from './cdrTranslators/CdrBodyModelTranslator'
import CdrResponseTranslator from './cdrTranslators/CdrResponseTranslator'
import { isMobileUsageRequest } from '@/types/mobile/MobileUsageType'
import { isMobileUsageResponse } from '../types/mobile/MobileUsageResponse'
import MobileUsageRequestBodyTranslator from './mobileUsageTranslators/MobileUsageRequestBodyTranslator'
import MobileusageResponseTranslator from './mobileUsageTranslators/MobileUsageResponseTranslator'
import { isOrderRequest } from '@/types/order/OrderType'
import OrderRequestBodyTranslator from './orderTranslators/OrderRequestBodyTranslator'
import { isOrderListResponse } from '@/types/order/OrderResponse'
import OrderResponseTranslator from './orderTranslators/OrderResponseTranslator'
import { isInvoiceListResponse } from '@/types/invoice/InvoiceResponse'
import InvoiceResponseTranslator from './invoiceTranslators/InvoiceResponseTranslator'
import { isInvoiceRequest } from '@/types/invoice/InvoiceType'
import InvoiceRequestTranslator from './invoiceTranslators/InvoiceRequestTranslator'
import { isSubscriptionRequest } from '@/types/subscription/SubscriptionType'
import SubscriptionRequestTranslator from './subscriptionTranslators/SubscriptionRequestTranslator'
import { isSubscriptionListResponse } from '@/types/subscription/SubscriptionResponse'
import SubscriptionResponseTranslator from './subscriptionTranslators/SubscriptionResponseTranslator'
import { isBillingAddress, isCustomer, isInvoiceMethod } from '@/types/customer/CustomerType'
import CustomerRequestTranslator from './customerTranslators/CustomerRequestTranslator'
import TicketResponseTranslator from './ticketTranslators/TicketResponseTranslator'
import { isCustomerResponse, isLeaderboardResponse } from '@/types/customer/CustomerResponseType'
import { isTicketListRequest } from '@/types/support/TicketType'
import CustomerResponseTranslator from './customerTranslators/CustomerResponseTranslator'
import TicketListRequestTranslator from './ticketTranslators/TicketListRequestTranslator'
import {
  isTicketHistoryListResponse,
  isTicketHistoryResponse,
  isTicketListReponseType,
  isTicketResponse,
} from '@/types/support/TicketResponseType'
import { isInternetStatusResponseType, isInternetUsageResponse } from '@/types/internet/InternetResponseType'
import InternetStatusResponseTranslator from './internetTranslators/InternetStatusResponseTranslator'
import { isInternetUsageRequest } from '@/types/internet/InternetType'
import InternetUsageRequestTranslator from './internetTranslators/InternetUsageRequestTranslator'
import InternetUsageResponseTranslator from './internetTranslators/InternetUsageResponseTranslator'
import TicketHistoryRequestTranslator from './ticketTranslators/TicketHistoryRequestTranslator'
import { isTicketHistoryRequest } from '@/types/support/TicketRequestType'
import TicketHistoryResponseTranslator from './ticketTranslators/TicketHistoryResponseTranslator'
import { isUserInfoResponse } from '@/types/userInfo/UserInfoResponseType'
import { isPermissionsReponseType } from '@/types/permissions/PermissionsResponseType'
import UserInfoResponseTranslator from './UserInfoTranslators/UserInfoResponseTranslator'
import { isTableFilterType } from '@/types/support/TicketFilterType'
import TicketFilterRequestTranslator from './ticketTranslators/TicketFilterRequestTranslator'
import PermissionsResponseTranslator from './permissionsTranslators/PermissionsResponseTranslator'
import ErrorResponseTranslator from './genericTranslators/ErrorResponseTranslator'
import { isErrorResponse } from '@/types/ErrorResponseTypes'
import LeaderboardResponseTranslator from './customerTranslators/LeaderboardResponseTranslator'
import LeaderboardRequestTranslator, { isLeaderboardRequest } from './customerTranslators/LeaderboardRequestTranslator'
import { isDocumentRequest } from '@/types/document/documentType'
import DocumentRequestTranslator from './documentTranslator/DocumentRequestTranslator'
import { isDocumentListResponse } from '@/types/document/documentResponse'
import DocumentResponseTranslator from './documentTranslator/DocumentResponseTranslator'
import { isAddressResponse, isCityListResponse, isStreetListResponse } from '@/types/address/addressReponse'
import AddressResponseTranslator from './addressTranslators/AddressResponseTranslator'
import { isCommissionListResponse } from '@/types/commission/CommissionResponse'
import CommissionResponseTranslator from './commissionTranslator/CommissionResponseTranslator'
import ZipCodeResponseTranslator from './addressTranslators/ZipCodeResponseTranslator'
import StreetResponseTranslator from './addressTranslators/StreetResponseTranslator'
import DealResponseTranslator from './dealTranslators/dealResponseTranslator'
import { isDealListResponse } from '@/types/deal/dealResponse'

class TranslationFactory {
  static getResponseTranslator(response: any): any {
    if (isCdrResponse(response)) {
      return CdrResponseTranslator
    }
    if (isMobileUsageResponse(response)) {
      return MobileusageResponseTranslator
    }
    if (isOrderListResponse(response)) {
      return OrderResponseTranslator
    }
    if (isSubscriptionListResponse(response)) {
      return SubscriptionResponseTranslator
    }
    if (isCustomerResponse(response)) {
      return CustomerResponseTranslator
    }
    if (isTicketListReponseType(response)) {
      return TicketResponseTranslator
    }
    if (isTicketHistoryListResponse(response)) {
      return TicketResponseTranslator
    }
    if (isTicketHistoryResponse(response)) {
      return TicketHistoryResponseTranslator
    }
    if (isTicketResponse(response)) {
      return TicketResponseTranslator
    }
    if (isInternetStatusResponseType(response)) {
      return InternetStatusResponseTranslator
    }
    if (isInternetUsageResponse(response)) {
      return InternetUsageResponseTranslator
    }
    if (isInvoiceListResponse(response)) {
      return InvoiceResponseTranslator
    }
    if (isDocumentListResponse(response)) {
      return DocumentResponseTranslator
    }
    if (isUserInfoResponse(response)) {
      return UserInfoResponseTranslator
    }
    if (isPermissionsReponseType(response)) {
      return PermissionsResponseTranslator
    }
    if (isLeaderboardResponse(response)) {
      return LeaderboardResponseTranslator
    }
    if (isAddressResponse(response)) {
      return AddressResponseTranslator
    }
    if (isCommissionListResponse(response)) {
      return CommissionResponseTranslator
    }
    if (isCityListResponse(response)) {
      return ZipCodeResponseTranslator
    }
    if (isStreetListResponse(response)) {
      return StreetResponseTranslator
    }
    if (isDealListResponse(response)) {
      return DealResponseTranslator
    }
    if (isErrorResponse(response)) {
      return ErrorResponseTranslator
    }
    return undefined
  }

  static getModelTranslator(model: any): any {
    if (isCdrBody(model)) {
      return CdrBodyModelTranslator
    }

    if (isTableFilterType(model)) {
      return TicketFilterRequestTranslator
    }

    if (isMobileUsageRequest(model)) {
      return MobileUsageRequestBodyTranslator
    }
    if (isTicketListRequest(model)) {
      return TicketListRequestTranslator
    }

    if (isOrderRequest(model)) {
      return OrderRequestBodyTranslator
    }
    if (isSubscriptionRequest(model)) {
      return SubscriptionRequestTranslator
    }
    if (isBillingAddress(model) || isInvoiceMethod(model)) {
      return CustomerRequestTranslator
    }
    if (isCustomer(model)) {
      return CustomerRequestTranslator
    }
    if (isInternetUsageRequest(model)) {
      return InternetUsageRequestTranslator
    }
    if (isTicketHistoryRequest(model)) {
      return TicketHistoryRequestTranslator
    }
    if (isInvoiceRequest(model)) {
      return InvoiceRequestTranslator
    }
    if (isDocumentRequest(model)) {
      return DocumentRequestTranslator
    }
    if (isLeaderboardRequest(model)) {
      return LeaderboardRequestTranslator
    }
    return undefined
  }
}
export { TranslationFactory }
